import { styled } from 'styled-components';
const StyledUnorderedList = styled.ul.withConfig({
  componentId: "aui__sc-c2qtk7-0"
})(["display:flex;margin:0 auto;padding:0;padding-bottom:1rem;li:last-child{border-bottom:none;}"]);
export { StyledUnorderedList };